const beforePreloadStylesheetIncludes = String.raw`{% extends '${require('../../../assets/layout').default.path}.html' -%}

{% block preloadStylesheetIncludes -%}
`; 

const betweenPreloadStylesheetIncludesAndStylesheetIncludes = String.raw`
{% endblock -%}

{% block stylesheetIncludes -%}
`;

const betweenStylesheetIncludesAndHeader = String.raw`
{% endblock -%}

{% block headerBlock -%}
`;

const betweenHeaderAndFooter = String.raw`
{% endblock -%}

{% block footerBlock -%}
`;

const betweenFooterAndFont = String.raw`
{% endblock -%}

{% block fontIncludeBlock -%}
`

const betweenFontAndPreloadLayoutJs = String.raw`
{% endblock -%}

{% block preloadLayoutJsBlock -%}
`

const betweenPreloadLayoutJsAndLayoutJs = String.raw`
{% endblock -%}

{% block layoutJsBlock -%}
`

const afterLayoutJs = String.raw`
{% endblock -%}
`

function generateLayoutTemplateHTMLContent(headerLocations, footerLocations, layoutPreloadJsInclude, layoutJsInclude, layoutPreloadCssInclude, layoutCssGlobalInclude, layoutCssTabletInclude, layoutCssMobileInclude, fontName="Roboto") {
    let headerInclude = "";
    if (headerLocations.html) {
        headerInclude = "    {% include '" + headerLocations.html + "' -%}";
    }
    let footerInclude = "";
    if (footerLocations.html) {
        footerInclude = "    {% include '" + footerLocations.html + "' -%}";
    }
    const fontInclude = `<link rel="preload" as="style" href="https://fonts.googleapis.com/css2?family=${fontName}:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap">\n`
    + `<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=${fontName}:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap">`;
    let preloadStylesheetIncludes = '';
    let stylesheetIncludes = '';
    let layoutPreloadJsIncludeString = '';
    let layoutJsIncludeString = '';

    if (layoutPreloadCssInclude) {
        preloadStylesheetIncludes = preloadStylesheetIncludes 
                                    + layoutPreloadCssInclude.global.join('\n') + '\n' 
                                    + layoutPreloadCssInclude.tablet.join('\n') + '\n' 
                                    + layoutPreloadCssInclude.mobile.join('\n');
    }
    if(layoutCssGlobalInclude) {
        stylesheetIncludes += layoutCssGlobalInclude.join('\n');
    }
    if (layoutCssTabletInclude) {
        stylesheetIncludes = stylesheetIncludes + '\n' + layoutCssTabletInclude.join('\n');
    }
    if (layoutCssMobileInclude) {
        stylesheetIncludes = stylesheetIncludes + '\n' + layoutCssMobileInclude.join('\n');
    }
    layoutPreloadJsIncludeString = layoutPreloadJsInclude.join('\n');
    layoutJsIncludeString += layoutJsInclude.join('\n');

    return (
        beforePreloadStylesheetIncludes +
        preloadStylesheetIncludes +
        betweenPreloadStylesheetIncludesAndStylesheetIncludes +
        stylesheetIncludes +
        betweenStylesheetIncludesAndHeader +
        headerInclude +
        betweenHeaderAndFooter +
        footerInclude +
        betweenFooterAndFont +
        fontInclude +
        betweenFontAndPreloadLayoutJs +
        layoutPreloadJsIncludeString +
        betweenPreloadLayoutJsAndLayoutJs +
        layoutJsIncludeString +
        afterLayoutJs
    );
}

export default generateLayoutTemplateHTMLContent;